import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void): () => void {
  document.addEventListener("visibilitychange", onChange);
  return () => document.removeEventListener("visibilitychange", onChange);
}

/**
 * Whether the tab is out of sight — another tab in front, the window
 * minimised. The same test React Query's focus manager makes before it
 * polls, so a screen that asks this and a query that pauses agree on what
 * „in the background“ means.
 */
export function useDocumentHidden(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => document.visibilityState === "hidden",
    () => false,
  );
}
